module.exports = require("./fr.js");